// extracted by mini-css-extract-plugin
export default {"OrganizationDefaultUsers":"OrganizationDefaultUsers_OrganizationDefaultUsers__aETBK","card":"OrganizationDefaultUsers_card__E8lug"};